import React, { useState, useEffect } from 'react';
import { Configuration, OpenAIApi } from "openai";
import './ChatGPT.css'

export const ChatGpt = () => {

    const openai = new OpenAIApi(new Configuration({ apiKey: "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" }))

    const [prompt, setPrompt] = useState("Explain quantum computing in simple terms");
    const [ansers, setAnsers] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {

        return () => { };
    }, [ansers]);


    const handleclick = async () => {
        setLoading(true);
        try {
            const response = await openai.createCompletion({
                model: "text-davinci-002",
                prompt: prompt,
                temperature: 0.5,
                max_tokens: 1000,
            });
            //debugger
            //            const completion = response.data.choices[0].text;
            //            const score = response.data.choices[0].score;
            //            const confidence = score * 100;
            //            const completion_text = completion.slice(prompt.length);


            setAnsers([{ q: prompt, a: response.data.choices[0].text }, ...ansers]);
            //setPrompt('');
        } catch (e) {
            alert(e);
        }

        setLoading(false);
    }

    const remove = (i) => {
        let newArray = [...ansers];
        newArray.splice(i, 1);
        setAnsers(newArray);
    }

    return (<div className='row mx-0 justify-content-center'>
        <div className='col-7'>

            <div className="text-center" >
                <div className="mt-3 mb-3 position-relative d-grid px-2 shadow " style={{ background: '#40414F', borderRadius: '10px', border: '1px solid #424242' }}>
                    <textarea
                        onInput={e => { e.target.style.height = e.target.scrollHeight + "px" }}
                        className="p-2"
                        style={{ background: 'transparent', color: 'white', overflow: 'hidden', resize: 'none', border: 0, paddingRight: '25px !important' }}
                        value={prompt}
                        onChange={(e) => setPrompt(e.target.value)}                >
                    </textarea>

                    <button className="btn btn-link position-absolute text-white"
                        style={{ bottom: 0, right: 0 }}
                        disabled={loading}
                        onClick={handleclick}
                    >{loading ? "Answering..." : <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4 mr-1" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>}
                    </button>

                </div>
            </div >

            <div>
                {ansers.map((x, i) =>
                    <div key={i} className="mb-1 p-2 position-relative" style={{ background: '#6e6e80', color: 'white' }}>
                        <button className="btn btn-sm btn-warning position-absolute"
                            onClick={() => remove(i)}
                            style={{ right: '0', top: 0 }}><i class="las la-times"></i></button>

                        <label style={{ color: '#fdff71' }}>{ansers.length - i}) {x.q}</label>
                        <div style={{ marginTop: -4 }}>
                            {/*<pre style={{ whiteSpace: 'pre-wrap', marginTop: -0 }}>{x.a}</pre>*/}
                            <pre style={{ whiteSpace: 'pre-wrap', marginTop: -0 }}>
                                <div  dangerouslySetInnerHTML={{ __html: x.a }}></div>
                            </pre>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </div>);

}
